<template>
    <div class="account">
        <!-- 流向列表 -->
        <vFlowSourceListsComponent :postList="postList" v-if="flag"></vFlowSourceListsComponent>
    </div>
</template>
<script>
import vFlowSourceListsComponent from '../../listComponent/basicdata/flowSourceLists/flowSourceListsComponent.vue';
export default {
    name: 'flowSourceLists',
    components: {
        vFlowSourceListsComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,

                tag: false,
                source_account_rid: true,
                source_file: true,
                product_rid: true,
                partner_rid: true,
                demander_rid: true,
                supplier_rid: true,
                no_demander: true,
                no_supplier: true,
                no_product: true,
                source_account_code: true,
                commodity_flow_source_rid: true,
                rid: true,
                business_rid: true,
                no_business: true,
                no_partner: true,
                ta_rid: true,
                date_range: true,
                ppa_code: true,
                month: false,
                source_demander: true,
                sup_supplier_rid: true,

                insertBtn: true,
                uploadBtn: true,
                updateBtn: true,
                productBtn: true,
                supplierBtn: true,
                demanderBtn: true,

                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>